import {SchemaDefinition} from './DbDefinitionMapperUtilities';
import DbView, {Views} from './DbView';

export type Schemas = {
    [ schemaName : string ] : DbSchema;
}

class DbSchema {

    /**
     * The name of this database schema
     */
    readonly name : string;

    /**
     * The views for this database schema
     */
    readonly views : Views;

    constructor( name : string, definition : SchemaDefinition ) {
        this.name = name.toUpperCase();
        this.views = {};

        // init views
        for ( const table in definition.tables ) {
            this.views[ table ] = new DbView( table, this.name, definition.tables[ table ] );
        }
    }

    toString() : string {
        return this.name.toUpperCase();
    }
}

export default DbSchema;
